import { Box, Button, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BusinessIcon from "@mui/icons-material/Business";
import TodayIcon from "@mui/icons-material/Today";

const loginButtonSx = {
  minWidth: "200px",
  minHeight: "80px",
  fontSize: "1.2rem",
  fontWeight: "bold",
  padding: "20px 40px",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: 6,
  },
  transition: "all 0.3s ease",
};

const Landing = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: colors.primary[500],
        gap: "30px",
        padding: "20px",
      }}
    >
      <Typography
        variant="h2"
        fontWeight="bold"
        color={colors.grey[100]}
        mb={4}
        textAlign="center"
      >
        Welcome
      </Typography>
      <Typography
        variant="h5"
        color={colors.grey[300]}
        mb={4}
        textAlign="center"
      >
        Please select your login type
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "30px",
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: "900px",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          size="large"
          startIcon={<AdminPanelSettingsIcon />}
          onClick={() => navigate("/admin-login")}
          sx={loginButtonSx}
        >
          Admin
        </Button>

        <Button
          variant="contained"
          color="secondary"
          size="large"
          startIcon={<BusinessIcon />}
          onClick={() => navigate("/partner-login")}
          sx={loginButtonSx}
        >
          Partners
        </Button>

        <Button
          variant="contained"
          color="secondary"
          size="large"
          startIcon={<TodayIcon />}
          onClick={() => navigate("/tap-login")}
          sx={loginButtonSx}
        >
          TAP
        </Button>
      </Box>
    </Box>
  );
};

export default Landing;



